import { render, staticRenderFns } from "./ProductFilterPopup.vue?vue&type=template&id=c8037466&scoped=true"
import script from "./ProductFilterPopup.vue?vue&type=script&lang=js"
export * from "./ProductFilterPopup.vue?vue&type=script&lang=js"
import style0 from "./ProductFilterPopup.vue?vue&type=style&index=0&id=c8037466&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8037466",
  null
  
)

export default component.exports